// extracted by mini-css-extract-plugin
export var section = "benefits-module--section--37R9R";
export var list = "benefits-module--list--1vZge";
export var jsAnimInit = "benefits-module--jsAnimInit--2QH9N";